import { Checkbox } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  label: string;
  description?: string;
  children: React.ReactNode;
};

const CheckboxSurvey = ({ label, description, children, ...props }: Props) => {
  const { t } = useTranslation();
  return (
    <Checkbox.Group
      label={label}
      description={description ?? t("checkbox.text")}
      errorProps={{ mt: "xs" }}
      orientation="vertical"
      styles={{
        description: { marginBottom: "1rem" },
      }}
      {...props}
    >
      {children}
    </Checkbox.Group>
  );
};

export default CheckboxSurvey;
